<mat-toolbar class="helper-bg-accent-50">
  @if (showLogo()) {
    <app-logo></app-logo>
  }
  <ng-content></ng-content>
</mat-toolbar>
